const copyUrl = (holeNumber, url) => {
  const formattedUrl = `${url}?hole=${holeNumber}`;
  navigator.clipboard.writeText(formattedUrl);
};

export default copyUrl;
